import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import React__default from 'react';
import { a as AppErrorMessage } from './AppFormField-e5fa211c.esm.js';
import { useFormikContext } from 'formik';
import { A as AppCodeInput } from './index-8501a8d1.esm.js';

function AppFormCodeInput(_ref) {
  let {
    value,
    setValue,
    name,
    ...otherProps
  } = _ref;
  const {
    setFieldValue,
    errors,
    touched,
    placeholder,
    values
  } = useFormikContext();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AppCodeInput, _extends({
    setValue: b => setFieldValue(name, b),
    value: values && values[name]
  }, otherProps)), errors[name] && values[name] != "" && /*#__PURE__*/React__default.createElement(AppErrorMessage, {
    top: -18,
    message: errors[name]
  }));
}
AppFormCodeInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppFormCodeInput"
};

export { AppFormCodeInput as A };
